// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2pA0_","buttons":"Footer_buttons__UZ5M3"};